import Avatar from 'common/Avatar/Avatar'

import Styles from './RightPanelContent.module.scss'
import { quoteCreditMap } from './utils'
import { useIsBlaze } from 'hooks/useIsBlaze'

type Props = {
  screen: string
}

const RightPanelContent = ({ screen }: Props) => {
  const { quote, credit, avatar, jobTitle } = quoteCreditMap[screen]
  const isBlaze = useIsBlaze()

  if (isBlaze) return null

  return (
    <div className={Styles.rightContent}>
      <div>
        <span className={Styles.leftMark}>“</span>
        <div className={Styles.rightQuote}>{quote || ''}</div>
        <span className={Styles.rightMark}>”</span>
      </div>
      {avatar && <Avatar className={Styles.rightAvatar} size={32} url={avatar} />}
      <div className={Styles.rightCredit}>
        <div>{credit || ''}</div>
        <div className={Styles.title}>{jobTitle || ''}</div>
      </div>
    </div>
  )
}

export default RightPanelContent
